document.addEventListener("DOMContentLoaded", function () {
  /**
   * Headlines with the "fancy" class have a shadow that moves with the mouse.
   */
  var headline_shadows = Array.from(
    document.getElementsByClassName("fancy__shadow")
  );

  document.addEventListener("mousemove", function (event) {
    var maxPixelsX = 20;
    var percentageX = event.x / window.innerWidth;
    var moveX = maxPixelsX * percentageX;
    if (percentageX < 50) {
      moveX = moveX - maxPixelsX;
    }

    var maxPixelsY = 20;
    var percentageY = event.y / window.innerHeight;
    var moveY = maxPixelsY * percentageY;
    if (percentageY < 50) {
      moveY = moveY - maxPixelsY;
    }

    headline_shadows.forEach((element) => {
      element.style.left = "50%";
      element.style.transform = "translate(calc(" + moveX + "px - 50%), " + moveY + "px)";
    });
  });
});
